<!-- 全景数据展板 -->
<template>
    <div class="teach-data-board">
      <div class="teach-data-board-left">
          <!-- 备课活动概览 -->
          <preparation-activity></preparation-activity>
          <!-- 备课活动参与榜top5 -->
          <activity-join-rank></activity-join-rank>
          <!-- 集体备课访问 -->
          <collective-visits></collective-visits>
      </div>
      <div class="teach-data-board-content">
        <teach-activity-info></teach-activity-info>
        <school-dynamics></school-dynamics>
        <!-- 教研资源建设 -->
        <teach-resource-build></teach-resource-build>
      </div>
      <div class="teach-data-board-right">
          <!-- 听评课活动概览 -->
          <listen-activity></listen-activity>
          <!-- 教师评课研讨榜top5 -->
          <listen-join-rank></listen-join-rank>
          <!-- 听评课访问 -->
          <listen-visits></listen-visits>
      </div>
    </div>
  </template>
  <script>
  import PreparationActivity from "@/views/site/modules/PreparationActivity.vue"
  import ActivityJoinRank from "@/views/site/modules/ActivityJoinRank.vue"
  import CollectiveVisits from "@/views/site/modules/CollectiveVisits.vue"
  import TeachActivityInfo from "@/views/site/modules/TeachActivityInfo.vue"
  import SchoolDynamics from "@/views/site/modules/SchoolDynamics.vue"
  import TeachResourceBuild from "@/views/site/modules/TeachResourceBuild.vue"
  import ListenActivity from "@/views/site/modules/ListenActivity.vue"
  import ListenJoinRank from "@/views/site/modules/ListenJoinRank.vue"
  import ListenVisits from "@/views/site/modules/ListenVisits.vue"
  export default {
    name: 'resource',
    components:{
        PreparationActivity,
        ActivityJoinRank,
        CollectiveVisits,
        TeachActivityInfo,
        SchoolDynamics,
        TeachResourceBuild,
        ListenActivity,
        ListenJoinRank,
        ListenVisits
    },
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    watch: {
  
    },
    computed: {
  
    },
    mounted() {
    },
  }
  </script>
  <style lang="scss" scoped>
 @font-face {
    font-family: DigifaceWide;
    src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
}
.teach-data-board{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  width: 100%;
  .teach-data-board-left{
    width: calc(25% - 10px);
  }
  .teach-data-board-content{
    width: calc(50% - 20px);
  }
  .teach-data-board-right{
    width: calc(25% - 10px);
  }
}
  </style>